export default function scrollToY(_scrollTargetY, _speed, _easing) {
  let scrollY = window.scrollY,
      scrollTargetY = _scrollTargetY || 0,
      speed = _speed || 2000,
      easing = _easing || 'easeOutSine',
      currentTime = 0;

  let time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));

  let PI_D2 = Math.PI / 2,
      easingEquations = {
          easeOutSine: function (pos) {
              return Math.sin(pos * (Math.PI / 2));
          },
          easeInOutSine: function (pos) {
              return (-0.5 * (Math.cos(Math.PI * pos) - 1));
          },
          easeInOutQuint: function (pos) {
              if ((pos /= 0.5) < 1) {
                  return 0.5 * Math.pow(pos, 5);
              }
              return 0.5 * (Math.pow((pos - 2), 5) + 2);
          }
      };

  function tick() {
      currentTime += 1 / 60;

      let p = currentTime / time;
      let t = easingEquations[easing](p);

      if (p < 1) {
        requestAnimationFrame(tick);
        window.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
      } else {
        window.scrollTo(0, scrollTargetY);
      }
  }

  // call it once to get started
  tick();
}


// WEBPACK FOOTER //
// ./src/vue/utils/scroll-to.js